import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
import { toCssVariables } from "../../lib/helpers";
import s from "./LoadingIndicator.module.css";
export const LoadingIndicator = ({ className, size, strokeWidth, style, ...restProps }) => {
    return (_jsx("div", { ...restProps, className: clsx(s.LoadingIndicator, className), style: style ||
            toCssVariables({
                "indicator-size": size,
                "indicator-stroke": strokeWidth,
            }) }));
};
//# sourceMappingURL=LoadingIndicator.js.map